"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context2dRenderUtil = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Utilities to try to make Canvas2D more civilized to use.
 */
class Context2dRenderUtil {
    /**
     * Add to vectors `a` and `b` and normalize the result to unit length.
     */
    static normalizedAddition(a, b, result) {
        return a
            .add(b, Context2dRenderUtil.tmp)
            .normalize(result);
    }
    /**
     * Returns unit vector perpendicular to the line formed by AB.
     */
    static getLineNormal(p1, p2, result) {
        return p2
            .subtract(p1, Context2dRenderUtil.tmp)
            .normalize(Context2dRenderUtil.tmp)
            .getNormal(result);
    }
    static moveTo(context, vec, offset, scaleFactor) {
        offset.scalarMultiply(scaleFactor, Context2dRenderUtil.tmp);
        vec.add(Context2dRenderUtil.tmp, Context2dRenderUtil.tmp);
        context.moveTo(Context2dRenderUtil.tmp.getX(), Context2dRenderUtil.tmp.getY());
    }
    static lineTo(context, vec, offset, scaleFactor) {
        offset.scalarMultiply(scaleFactor, Context2dRenderUtil.tmp);
        vec.add(Context2dRenderUtil.tmp, Context2dRenderUtil.tmp);
        context.lineTo(Context2dRenderUtil.tmp.getX(), Context2dRenderUtil.tmp.getY());
    }
    static closeMidSegment(context, packedColor) {
        context.fillStyle = rc_js_util_1.RgbaColorPacker.makeDomColorString(packedColor);
        context.fill();
        context.beginPath();
    }
}
exports.Context2dRenderUtil = Context2dRenderUtil;
Context2dRenderUtil.tmp = new rc_js_util_1.Vec2.f64();
//# sourceMappingURL=context2d-render-util.js.map